import { useEffect } from 'react';
import { InteractionRequiredAuthError, InteractionStatus } from '@azure/msal-browser';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';

import { loginRequest } from './authConfig';

export const useAuthHandler = () => {
    const { instance, inProgress } = useMsal();
    const isAuthenticated = useIsAuthenticated();

    useEffect(() => {
        if (instance && inProgress !== InteractionStatus.Startup) {
            instance
                .handleRedirectPromise()
                .then((response) => {
                    if (response) {
                        console.log('handleRedirectPromise response:', response);
                    }
                })
                .catch((error) => {
                    console.error('Error during handleRedirectPromise in useAuthHandler:', error);
                });
        }
    }, [instance, inProgress]);

    useEffect(() => {
        const attemptLoginIfNeeded = async () => {
            if (instance && inProgress === InteractionStatus.None && !isAuthenticated) {
                console.log(
                    'useAuthHandler: User is not authenticated and no interaction is in progress, attempting login...'
                );
                try {
                    if (!instance.getActiveAccount()) {
                        console.log('useAuthHandler: No active account, initiating loginRedirect.');
                        await instance.loginRedirect(loginRequest);
                    }
                } catch (error) {
                    if (error instanceof InteractionRequiredAuthError) {
                        console.log(
                            'useAuthHandler: Interaction required, redirecting to login (loginRedirect).'
                        );
                        await instance.loginRedirect(loginRequest);
                    } else {
                        console.error(
                            'useAuthHandler: Unexpected error during automatic login attempt: ',
                            error
                        );
                    }
                }
            }
        };

        attemptLoginIfNeeded();
    }, [isAuthenticated, inProgress, instance]);

    return { isAuthenticated, inProgress };
};
